import API_URL from '../config/api';

// Helper para obtener headers con autenticación
export const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    'Authorization': token ? `Bearer ${token}` : ''
  };
};

// Helper para hacer fetch con autenticación
export const fetchWithAuth = async (url, options = {}) => {
  const token = localStorage.getItem('token');

  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
      'Authorization': token ? `Bearer ${token}` : ''
    }
  };

  const response = await fetch(url, { ...options, ...defaultOptions });

  // Si el token ha expirado o no es válido, redirigir al login
  if (response.status === 401) {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/login';
    throw new Error('Sesión expirada');
  }

  return response;
};

export default API_URL;